import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import dataPredictionModel from '../../../utilities/images/dataPredictionModel.png';
import predictiveModels from '../../../utilities/images/predictive-models.png';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';
import ProjectActionButtons from './ProjectActionButtons';

interface DataPredictionDialogProps {
    open: boolean;
    onClose: () => void;
}

const DataPredictionDialog: React.FC<DataPredictionDialogProps> = ({ open, onClose }) => {
  const isCompactScreen = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isCompactScreen}
      TransitionComponent={SlideUpTransition}
      sx={{
        '& .MuiDialog-paper': {
          margin: isCompactScreen ? 0 : 2,
          width: isCompactScreen ? '100vw' : 'auto',
          maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
          maxHeight: isCompactScreen ? '100dvh' : '95dvh',
          borderRadius: isCompactScreen ? 0 : 3,
          overflow: isCompactScreen ? 'auto' : 'hidden',
        },
      }}
    >
      <div className="card">
        <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
        
        <div className="title">{t("projectDialogs.dataPrediction.title")}</div>
        
        <div className="card-content">
          <ImageCarousel images={[dataPredictionModel, predictiveModels]} alt={t("projectDialogs.dataPrediction.title")} />
          
          <div className="description">
            <div className="left-box">
              {t("projectDialogs.dataPrediction.description")}
            </div>
            
            <div className="right-box">
              <div>React</div>
              <div>TypeScript</div>
              <div>CSS</div>
              <div>Material UI</div>
            </div>
          </div>
        </div>
        
        <ProjectActionButtons githubUrl="https://github.com/SirArchy/ProjektMFG" />
      </div>
    </Dialog>
  );
};

export default DataPredictionDialog;